module.exports = __webpack_public_path__ + "img/SSL-Logo.dee733dc.svg";